var map = {
	"./legenda.png": 49163,
	"./lte.svg": 97000,
	"./qsfp.svg": 41798,
	"./rj45-edit.svg": 2647,
	"./rj45.svg": 62489,
	"./sfp.svg": 73458
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96789;